import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategorySection from './components/CategorySection';
import LatestSection from './components/LatestSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <SEOHead
        title="韩国漫画网-韩漫在线阅读_免费的韩国漫画_无删减下拉式韩漫大全"
        description="韩漫在线阅读,免费韩国漫画,无删减,下拉式大全,完整内容。我们提供无删减下拉式韩漫大全供您免费在线阅读，确保作品内容的完整性与原汁原味，为您保留最真实的故事情节。"
        keywords="韩漫在线阅读,免费韩国漫画,无删减,下拉式大全,完整内容,韩国漫画网,韩漫"
        canonicalUrl="https://koreanmanga.example.com/"
        schemaData={[
          {
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '韩国漫画网 - 首页',
            description: '韩国漫画网提供无删减下拉式韩漫大全免费在线阅读',
            url: 'https://koreanmanga.example.com/',
            inLanguage: 'zh-CN',
          },
        ]}
      />

      <Navbar />

      <main>
        <HeroSection />
        <FeaturedSection />
        <CategorySection />
        <LatestSection />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
}